// import { useMemo } from "react";
import {
  Avatar,
  Box,
  HStack,
  IconButton,
  Skeleton,
  SkeletonCircle,
  // IconButton,
  Text,
  // useColorMode,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
// import { useLocation } from "react-router-dom";

// import { CustomH2 } from "../ui/forms/texts";
import { Menu } from "lucide-react";
import { useGetProfile } from "../../api/user/user.api";
import { removeUnderscores } from "../../utils/helpers/functions";
import { CustomDrawer } from "../ui/modals";
import SideBar from "./sidebar";
// import { Moon, SunMoon } from "lucide-react";

const TopBar = ({
  scrollDirection,
}: {
  scrollDirection: "down" | "up" | "top";
}) => {
  const sidebarDisclosure = useDisclosure();
  const { data: { data: user } = { data: undefined } } = useGetProfile();

  // const { colorMode, toggleColorMode } = useColorMode();
  // const { pathname } = useLocation();

  // const title = useMemo(() => {
  //   return pathname.includes("/content/category")
  //     ? "Content Category"
  //     : pathname.includes("/content/summary")
  //     ? "Content Summary"
  //     : pathname.includes("/content/data")
  //     ? "Content Data"
  //     : pathname.includes("/subscription")
  //     ? "Subscription Plans"
  //     : pathname.includes("/quiz")
  //     ? "Quiz"
  //     : pathname.includes("/badges")
  //     ? "Badges"
  //     : pathname.includes("/users")
  //     ? "Users"
  //     : pathname.includes("/admin")
  //     ? "Admins"
  //     : "Dashboard";
  // }, [pathname]);

  return (
    <>
      <Box
        as={"header"}
        borderBottom={"1px solid transparent"}
        borderBottomColor={"neutral.700"}
        position={"fixed"}
        left={{ base: 0, xl: "230px" }}
        zIndex={10}
        top={0}
        right={0}
        userSelect={"none"}
        backdropFilter={"blur(8px)"}
        bg={
          scrollDirection === "top"
            ? "background"
            : scrollDirection === "up"
              ? "rgba(255, 255, 255, 0.7)"
              : "rgba(255, 255, 255, 0.7)"
        }
        boxShadow={
          scrollDirection === "top"
            ? "none"
            : scrollDirection === "up"
              ? "md"
              : "md"
        }
        transition="all 0.35s cubic-bezier(0.645,0.045,0.355,1) 0s"
      >
        <Box id={"__container"}>
          <HStack
            flex={1}
            height={"74px"}
            px={{ base: "24px", md: "42px" }}
            justifyContent={"space-between"}
          >
            <Box mr="auto">
              {/* <CustomH2
                headerProps={{
                  fontWeight: 600,
                  color: "text.400",
                }}
              >
                {title}
              </CustomH2> */}
              <IconButton
                variant={"link"}
                aria-label="menu"
                display={{ base: "flex", xl: "none" }}
                icon={<Menu size={34} />}
                onClick={sidebarDisclosure.onOpen}
              />
            </Box>

            <HStack spacing={4}>
              {user ? (
                <HStack
                  className="slow-transition"
                  pl={4}
                  role={"button"}
                  tabIndex={0}
                  _hover={{ bg: "neutral.700" }}
                  py={1}
                  width={"fit-content"}
                  spacing={3}
                  justifyContent={"flex-end"}
                >
                  <Box>
                    <Text
                      color={"foreground"}
                      textStyle={"normal"}
                      textAlign={"end"}
                      fontWeight={500}
                      mb={0.5}
                    >
                      {user.userType
                        ? removeUnderscores(user.userType)
                        : "Admin"}
                    </Text>
                    <Text
                      display={{ base: "none", sm: "block" }}
                      color={"foreground"}
                      textStyle={"medium"}
                      textAlign={"end"}
                      opacity={0.7}
                    >
                      {user.email || "admin email"}
                    </Text>
                  </Box>
                  <Box display={{ base: "block" }}>
                    <Avatar name={user.firstName + " " + user.lastName} />
                  </Box>
                </HStack>
              ) : (
                <HStack>
                  <VStack>
                    <Skeleton width={"140px"} height={"14px"} />
                    <Skeleton width={"140px"} height={"10px"} />
                  </VStack>
                  <SkeletonCircle width={"40px"} height={"40px"} />
                </HStack>
              )}

              {/* <IconButton
                onClick={toggleColorMode}
                colorScheme="par"
                variant={"text"}
                aria-label="Toggle theme"
                icon={
                  colorMode === "light" ? (
                    <Moon width={18} />
                  ) : (
                    <SunMoon width={18} />
                  )
                }
              /> */}
            </HStack>
          </HStack>
        </Box>
      </Box>

      {/* SIDEBAR - mobile */}
      <CustomDrawer
        disclosure={sidebarDisclosure}
        size="md"
        drawerContentProps={{ px: "20px", bg: "brand" }}
        placement="left"
        isMenu
        hideOverlay
      >
        <SideBar onClose={sidebarDisclosure.onClose} isMobile />
      </CustomDrawer>
    </>
  );
};

export default TopBar;
